"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var aion_1 = __importDefault(require("@adoratorio/aion"));
var declarations_1 = require("./declarations");
var easing_1 = __importDefault(require("./easing"));
var property_1 = __importDefault(require("./property"));
var target_1 = __importDefault(require("./target"));
var utils_1 = require("./utils");
var Apollo = /** @class */ (function () {
    function Apollo(options) {
        var _this = this;
        this.cursorPositionPrev = { x: 0, y: 0 };
        this._velocity = { x: 0, y: 0 };
        this._direction = { x: 0, y: 0 };
        this.activeMouseTarget = null;
        this.activeCursorTarget = null;
        this.frame = function (delta) {
            _this.options.callbacks.frame(_this.coords, _this.mouse);
            _this._properties.forEach(function (property) { return property.frame(delta); });
            _this._targets.forEach(function (target) { return target.frame(delta); });
            _this.checkTargets();
            _this.cursorXTimeline.final = _this.mouseRenderPosition.x;
            _this.cursorYTimeline.final = _this.mouseRenderPosition.y;
            var deltaT = Math.min(Math.max(delta, 0), _this.options.easing.duration);
            var time = _this.options.easing.mode(deltaT / _this.options.easing.duration);
            _this.cursorXTimeline.current = _this.cursorXTimeline.initial + (time * (_this.cursorXTimeline.final - _this.cursorXTimeline.initial));
            _this.cursorYTimeline.current = _this.cursorYTimeline.initial + (time * (_this.cursorYTimeline.final - _this.cursorYTimeline.initial));
            var position = {
                x: _this.cursorXTimeline.current - _this.cursorBounding.width / 2,
                y: _this.cursorYTimeline.current - _this.cursorBounding.height / 2,
            };
            var roundedPosition = {
                x: Math.round(_this.cursorXTimeline.current - _this.cursorBounding.width / 2),
                y: Math.round(_this.cursorYTimeline.current - _this.cursorBounding.height / 2),
            };
            _this.cursorPosition = _this.options.renderByPixel ? roundedPosition : position;
            _this.render(delta);
        };
        this.render = function (delta) {
            if (!_this.options.render)
                return;
            _this.options.callbacks.render(_this.coords, _this.mouse);
            _this._properties.forEach(function (property) { return property.render(delta); });
            _this._targets.forEach(function (target) { return target.render(delta); });
            if (_this.cursorElement !== null) {
                var transform = "translateX(" + _this.cursorPosition.x + "px) translateY(" + _this.cursorPosition.y + "px) translateZ(0px)";
                _this.cursorElement.style.transform = transform;
            }
            _this.postRender(delta);
        };
        this.mouseMove = function (event) {
            _this.mousePosition = {
                x: event.clientX,
                y: event.clientY,
            };
            if (!_this._trackMouse)
                return;
            _this.mouseRenderPosition = _this.mousePosition;
        };
        this.touchMove = function (event) {
            _this.mousePosition = {
                x: event.touches[0].clientX,
                y: event.touches[0].clientY,
            };
            if (!_this._trackMouse)
                return;
            _this.mouseRenderPosition = _this.mousePosition;
        };
        utils_1.createProp();
        var defaults = {
            cursor: document.querySelector('.apollo__cursor'),
            props: [],
            easing: {
                mode: Apollo.EASING.CUBIC,
                duration: 1000,
            },
            targets: [],
            hiddenUntilFirstInteraction: false,
            initialPosition: { x: 0, y: 0 },
            detectTouch: false,
            emitGlobal: false,
            aion: null,
            renderByPixel: false,
            callbacks: {
                frame: function () { },
                render: function () { },
                postRender: function () { },
            },
            render: true,
        };
        this.options = __assign({}, defaults, options);
        if (typeof this.options.callbacks.frame === 'undefined')
            this.options.callbacks.frame = function () { };
        if (typeof this.options.callbacks.render === 'undefined')
            this.options.callbacks.render = function () { };
        if (typeof this.options.callbacks.postRender === 'undefined')
            this.options.callbacks.postRender = function () { };
        // Set the initial mouse position
        this.mousePosition = this.options.initialPosition;
        this.mouseRenderPosition = this.mousePosition;
        this.cursorPosition = this.mousePosition;
        this.cursorBounding = this.cursorElement.getBoundingClientRect();
        this.cursorXTimeline = {
            start: 0,
            duration: this.options.easing.duration,
            initial: this.cursorPosition.x,
            current: this.cursorPosition.x,
            final: this.cursorPosition.x,
        };
        this.cursorYTimeline = {
            start: 0,
            duration: this.options.easing.duration,
            initial: this.cursorPosition.y,
            current: this.cursorPosition.y,
            final: this.cursorPosition.y,
        };
        // Create or set the engine
        if (this.options.aion !== null) {
            this.engine = this.options.aion;
        }
        else {
            this.engine = new aion_1.default();
            this.engine.start();
        }
        // For each prop descriptor start the property
        this._properties = [];
        this.options.props.forEach(function (prop) {
            _this._properties.push(new property_1.default(prop));
        });
        // Add all the targets
        this._targets = [];
        this.options.targets.forEach(function (target) {
            target.elements.forEach(function (element, index) {
                _this._targets.push(new target_1.default(element, target, index));
            });
        });
        this.frameHandler = function (delta) { _this.frame(delta); };
        this.engine.add(this.frameHandler, 'apollo-frame');
        this.bindEvents();
        this._trackMouse = true;
    }
    Apollo.prototype.postRender = function (delta) {
        this._properties.forEach(function (property) { return property.postRender(delta); });
        this._targets.forEach(function (target) { return target.postRender(delta); });
        this.cursorXTimeline.initial = this.cursorXTimeline.current;
        this.cursorYTimeline.initial = this.cursorYTimeline.current;
        this._velocity = {
            x: (this.cursorPosition.x - this.cursorPositionPrev.x) / delta,
            y: (this.cursorPosition.y - this.cursorPositionPrev.y) / delta,
        };
        this._direction = {
            x: this._velocity.x > 0 ? 1 : -1,
            y: this._velocity.y > 0 ? 1 : -1,
        };
        this.velocity.x = Math.abs(this._velocity.x);
        this.velocity.y = Math.abs(this._velocity.y);
        this.options.callbacks.postRender(this.coords, this.mouse);
        this.cursorPositionPrev = this.cursorPosition;
    };
    Apollo.prototype.checkTargets = function () {
        // Check the out
        if (this.activeMouseTarget !== null && !utils_1.isInRect(this.mousePosition, this.activeMouseTarget.boundings)) {
            utils_1.emitEvent('apollo-mouse-leave', { target: this.activeMouseTarget });
            this.activeMouseTarget.descriptor.callback(this.activeMouseTarget, 'apollo-mouse-leave');
            this.activeMouseTarget = null;
        }
        if (this.activeCursorTarget !== null && !utils_1.isInRect(this.cursorPosition, this.activeCursorTarget.boundings)) {
            utils_1.emitEvent('apollo-cursor-leave', { target: this.activeCursorTarget });
            this.activeCursorTarget.descriptor.callback(this.activeCursorTarget, 'apollo-cursor-leave');
            this.activeCursorTarget = null;
        }
        var matchedOneMouse = false;
        var matchedOneCursor = false;
        for (var i = 0; i < this._targets.length; i++) {
            var target = this._targets[i];
            if (utils_1.isVisible(target)) {
                // Check the in
                if (utils_1.isInRect(this.mousePosition, target.boundings) && !matchedOneMouse) {
                    if (this.activeMouseTarget === null || this.activeMouseTarget.id !== target.id) {
                        if (this.activeMouseTarget !== null) {
                            utils_1.emitEvent('apollo-mouse-leave', { target: this.activeMouseTarget });
                            this.activeMouseTarget.descriptor.callback(this.activeMouseTarget, 'apollo-mouse-leave');
                        }
                        this.activeMouseTarget = target;
                        utils_1.emitEvent('apollo-mouse-enter', { target: this.activeMouseTarget });
                        this.activeMouseTarget.descriptor.callback(this.activeMouseTarget, 'apollo-mouse-enter');
                    }
                    matchedOneMouse = true;
                }
                if (utils_1.isInRect(this.cursorPosition, target.boundings) && !matchedOneCursor) {
                    if (this.activeCursorTarget === null || this.activeCursorTarget.id !== target.id) {
                        if (this.activeCursorTarget !== null) {
                            utils_1.emitEvent('apollo-cursor-leave', { target: this.activeCursorTarget });
                            this.activeCursorTarget.descriptor.callback(this.activeCursorTarget, 'apollo-cursor-leave');
                        }
                        this.activeCursorTarget = target;
                        utils_1.emitEvent('apollo-cursor-enter', { target: this.activeCursorTarget });
                        this.activeCursorTarget.descriptor.callback(this.activeCursorTarget, 'apollo-cursor-enter');
                    }
                    matchedOneCursor = true;
                }
            }
        }
    };
    Apollo.prototype.bindEvents = function () {
        document.body.addEventListener('mousemove', this.mouseMove, { passive: true });
        if (this.options.detectTouch) {
            document.body.addEventListener('touchstart', this.touchMove, { passive: true });
            document.body.addEventListener('touchmove', this.touchMove, { passive: true });
        }
    };
    Apollo.prototype.addProperties = function (props) {
        var _this = this;
        props.forEach(function (prop) {
            _this._properties.push(new property_1.default(prop));
        });
    };
    Apollo.prototype.removeProperty = function (id) {
        var index = this._properties.findIndex(function (prop) { return prop.id === id; });
        if (index > -1) {
            delete this._properties[index];
            this._properties.splice(index, 1);
        }
    };
    Apollo.prototype.addTarget = function (target) {
        var _this = this;
        target.elements.forEach(function (element, index) {
            if (element._apolloId !== '-1')
                return;
            _this._targets.push(new target_1.default(element, target, index));
        });
    };
    Apollo.prototype.removeTarget = function (id) {
        for (var index = this._targets.length - 1; index >= 0; index--) {
            var target = this._targets[index];
            if (target.descriptor.id === id) {
                delete this._targets[index];
                this._targets.splice(index, 1);
            }
        }
    };
    Apollo.prototype.pullFromTarget = function (element) {
        for (var index = this._targets.length - 1; index >= 0; index--) {
            var target = this._targets[index];
            if (target.id === element._apolloId) {
                element._apolloId = '-1';
                delete this._targets[index];
                this._targets.splice(index, 1);
            }
        }
    };
    Apollo.prototype.getProperty = function (id) {
        return this._properties.find(function (p) { return p.id === id; });
    };
    Object.defineProperty(Apollo.prototype, "trackMouse", {
        get: function () {
            return this._trackMouse;
        },
        set: function (value) {
            this._trackMouse = value;
        },
        enumerable: true,
        configurable: true
    });
    Apollo.prototype.startMouseTracking = function () {
        this._trackMouse = true;
    };
    Apollo.prototype.stopMouseTracking = function () {
        this._trackMouse = false;
    };
    Object.defineProperty(Apollo.prototype, "cursorElement", {
        get: function () {
            return this.options.cursor;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Apollo.prototype, "coords", {
        get: function () {
            return this.cursorPosition;
        },
        set: function (coords) {
            this.mouseRenderPosition = coords;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Apollo.prototype, "mouse", {
        get: function () {
            return this.mousePosition;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Apollo.prototype, "velocity", {
        get: function () {
            return this._velocity;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Apollo.prototype, "direction", {
        get: function () {
            return this._direction;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Apollo.prototype, "properties", {
        get: function () {
            return this._properties;
        },
        enumerable: true,
        configurable: true
    });
    Apollo.EASING = easing_1.default;
    Apollo.PROPERTY_TYPE = declarations_1.PROPERTY_TYPE;
    Apollo.PROPERTY_SUFFIX = declarations_1.PROPERTY_SUFFIX;
    return Apollo;
}());
exports.default = Apollo;
